import { createAction, props } from '@ngrx/store';
import { OrderTemplateInterfaceWithId } from '@sk/sk-interfaces';

export const loadTemplates = createAction('[Templates] Load Templates');

export const loadTemplatesSuccess = createAction(
  '[Templates] Load Templates Success',
  props<{ templates: OrderTemplateInterfaceWithId[] }>()
);

export const loadTemplatesFailure = createAction(
  '[Templates] Load Templates Failure',
  props<{ error: any }>()
);

// ADD Templates
export const addTemplate = createAction(
  '[Templates] add Template',
  props<{ template: OrderTemplateInterfaceWithId }>()
);


export const addTemplateSuccess = createAction(
  '[Templates] added Template with success',
  props<any>()
);

export const addTemplateError = createAction(
  '[Templates] added Template failed',
  props<{ error: Error }>()
);


// REMOVE Template
export const removeTemplate = createAction(
  '[Templates] removed',
  props<{
    id: string,
  }>()
);

export const removeTemplateSuccess = createAction(
  '[Templates] removed with success',
  props<any>()
);

export const removeTemplateError = createAction(
  '[Templates] removed failed',
  props<{ error: Error }>()
);


// UPDATE Templates
export const updateTemplate = createAction(
  '[Templates] update',
  props<{
    id: string,
    changes: OrderTemplateInterfaceWithId
  }>()
);


export const updateTemplateSuccess = createAction(
  '[Templates] update success',
  props<any>()
);

export const updateTemplatesError = createAction(
  '[Templates] update failed',
  props<{ error: Error }>()
);


// FIRESTORE ACTIONS

export const queryFireStoreTemplates = createAction(
  '[Templates] query templates',
  props<any>()
);


export const queryFireStoreTemplatesError = createAction(
  '[Templates] error at query templates',
  props<{ error: Error }>()
);


export const fromFireStoreAddTemplate = createAction(
  '[Templates] added by Firestore',
  props<{ template: OrderTemplateInterfaceWithId }>()
);

export const fromFireStoreModifyTemplate = createAction(
  '[Templates] modified by Firestore',
  props<{ template: OrderTemplateInterfaceWithId }>()
);


export const fromFireStoreRemoveTemplate = createAction(
  '[Templates] removed by Firestore',
  props<{
    id: string,
  }>()
);



